import {Condition} from '../../../../../types';
import {TaskFieldRequiredState} from '../../../../../../../constants/tasks';

export const meetsVisibilityCriteria = (
    required: TaskFieldRequiredState,
    conditions: Nullable<Condition[]>,
    values: {}
) => {
  if (required ===
    TaskFieldRequiredState.REQUIRED_BY_CONDITION) {
    return conditions
        ?.every(({dependentFieldId, expectedValue}) =>
          values[dependentFieldId] === expectedValue);
  } else {
    return true;
  }
};
